import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '~/types';
import { CONFIG } from '~/config';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const isAuthenticated = useSelector<RootState, boolean>(({ user }) => user?.isAuthenticated || false);

  if (!isAuthenticated && CONFIG.env.featureFlag.onlyRegisteredUsersCanAccess) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
